import React from "react"

import { AppProvidersAutocomplete } from "@components"
import { useUserSettingsProvider, useUserSettingsProviderValidator } from "../../../@hooks"
import { userSettingProvidersFormData } from "../../../@signals"


export default function UserSettingProviderDrawerProviders() {
	const { handleChangeProviderFormData } = useUserSettingsProvider()
	const { providerError } = useUserSettingsProviderValidator()

    return <AppProvidersAutocomplete
		label="Provider"
		disableClearable
		multiple={false}
		placeholder="Select provider(s)"
		error={providerError}
		value={userSettingProvidersFormData.value?.id_provider || []}
		onChange={e => handleChangeProviderFormData(e.target.value, 'id_provider')}
	/>
}